// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';

import Thailand from '../_raw/flag/icon_flag_thailand.png';

export default () => <img src={Thailand} alt="Thailand" />;
